import ReactPlayer from 'react-player';

export default function VideoBackground({ children, videoUrl, showBlur = false, opacity = 1 }) {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'hidden', opacity, filter: showBlur ? 'blur(1px) brightness(0.8)' : '' }}>
        <ReactPlayer
          url={videoUrl}
          playing={true}
          loop={true}
          muted={true}
          width={'100%'}
          height={'100%'}
          style={{ objectFit: 'cover' }}
          config={{ file: { attributes: { style: { objectFit: 'cover', width: '100%', height: '100%' } } } }}
        />
      </div>

      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {children}
      </div>
    </div>
  );
}
